// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomEvent } from '@shared/utils/CustomEvents';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import TerceraAlwaysMiddlePartPartial from '@front/templates/TerceraAlwaysMiddlePartPartial.html';
import { ContainerControl } from '../elements/ContainerControl';
import { BOTTOM_WINDOWS_MARGIN, TOP_WINDOWS_MARGIN, WINDOW_SIDE_BORDERS_WIDTH } from '../UtilsClasses/SizeConstants';
import { BrandingUtils } from '@shared/commons/UtilsClasses/BrandingUtils';
import { ApplicationInfo } from '@shared/commons/ApplicationInfo';
import { Resources } from '@shared/localizations/Resources';
import $ from 'jquery';
import { TerceraButtonEvents } from '@shared/utils/Enums/ButtonEnums';
import { TerceraLinkControlConstants } from '../UtilsClasses/TerceraLinkControlConstants';
import { FullScreenManager } from '../UtilsClasses/FullScreenManager';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { DynProperty } from '@shared/commons/DynProperty';
import { DataCache } from '@shared/commons/DataCache';
import { LinkedSystem, LinkedSystemAccLinkingValue } from '../misc/LinkedSystem';
import { ThemeManager } from '../misc/ThemeManager';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import { showContextMenu } from '@components/webdesktop/elements/ContextMenu/ContextMenuHost';
export class TerceraWindowBase extends ContainerControl {
    constructor() {
        super(...arguments);
        this.forceUpdate = false;
        this.OnResize = new CustomEvent();
        this.OnClose = new CustomEvent();
        this.OnComplete = new CustomEvent();
        this.forceCloseOnLogout = true;
        this.allowResizers = {
            left: true,
            top: true,
            right: true,
            bottom: true
        };
        this.onMouseMoveEvt = new CustomEvent();
        this.ExternalScreenStorage = null;
    }
    initZIndex() {
        void this.set('zIndex', TerceraWindowBase.getNextZIndex());
    }
    static getNextZIndex() {
        return ++TerceraWindowBase.ZIndex;
    }
    oninit() {
        super.oninit();
        this.initZIndex();
        this.OnResize = new CustomEvent();
        this.OnClose = new CustomEvent();
        this.OnComplete = new CustomEvent();
    }
    getType() {
        return 'TerceraWindowBase';
    }
    // #region private service methods
    //
    // on complete -> subscribe for value changed, if necessary
    //
    oncomplete() {
        var _a;
        super.oncomplete();
        this.observe('header', (newValue) => {
            void this.set({ headerInnerHTML: newValue });
        }); // для возможности сетить в хедер html элементы (например если часть текста должна быть другого цвета как в #100287)
        this.observe('isAccountLinkShow', (newValue) => {
            const newState = newValue ? TerceraLinkControlConstants.STATE_ALL : TerceraLinkControlConstants.STATE_NONE;
            void this.set({ accountLinkValue: newState, isAccountLinkShowState: this.getIsAccountLinkShow() });
        });
        if ((_a = this.Controls) === null || _a === void 0 ? void 0 : _a.closeCrossBtn) {
            this.Controls.closeCrossBtn.on(TerceraButtonEvents.onClick, this.onCloseButtonClick.bind(this));
        }
        this.on('fullscreenModeClick', this.toggleFullscreenMode.bind(this));
        this.localize();
        this.OnComplete.Raise(this);
    }
    // #region FullscreenMode
    toggleFullscreenMode(e) {
        return __awaiter(this, void 0, void 0, function* () {
            void this.set('isInFullScreenMode', true);
            const self = this.getControl();
            this.closeAddidionalScreens(MainWindowManager.MainWindow);
            FullScreenManager.fullscreenExit.Subscribe(this.exitFullscreenCallback, this);
            if (self.requestFullscreen != null) {
                yield self.requestFullscreen();
            }
            else if (self['mozRequestFullScreen'] != null) {
                // Firefox
                yield self['mozRequestFullScreen']();
            }
            else if (self['webkitRequestFullscreen'] != null) {
                // Chrome, Safari, Opera
                yield self['webkitRequestFullscreen']();
            }
            else if (self['msRequestFullscreen'] != null) {
                // IE/Edge
                yield self['msRequestFullscreen']();
            }
        });
    }
    exitFullscreenCallback() {
        void this.set('isInFullScreenMode', false);
        this.closeAddidionalScreens(this);
        FullScreenManager.fullscreenExit.UnSubscribe(this.exitFullscreenCallback, this);
    }
    onActiveControlChanged(newVal) {
        this.activePanelRootDiv = !isNullOrUndefined(newVal) && newVal.rendered ? newVal.find('div') : null;
        this.activePanel = newVal !== null && newVal !== void 0 ? newVal : null;
    }
    onMouseUp(event) {
        var _a, _b;
        const activeControl = this.get('activeControl');
        if (isNullOrUndefined(activeControl))
            return;
        if (activeControl.get('movable') === true) {
            let activeControlactiveControl = activeControl.get('activeControl');
            while (!isNullOrUndefined(activeControlactiveControl)) {
                activeControlactiveControl.set('onProcessMove', false);
                activeControlactiveControl = activeControlactiveControl.get('activeControl');
            }
            activeControl.set('onProcessMove', false);
            delete activeControl.movingParameters;
            const lastMouseMoveX = this.lastMouseMoveX;
            const lastMouseMoveY = this.lastMouseMoveY;
            if (lastMouseMoveX !== undefined && lastMouseMoveY !== undefined) {
                activeControl.setLocation(lastMouseMoveX, lastMouseMoveY);
                delete this.lastMouseMoveX;
                delete this.lastMouseMoveY;
                delete this.lastMouseMoveEvent;
            }
            (_a = this.ExternalScreenStorage) === null || _a === void 0 ? void 0 : _a.EnableAllScreens();
        }
        if (activeControl.get('resizable') === true) {
            activeControl.onProcessResize = false;
            delete activeControl.onProcessResize;
            this.onResizeEnd();
            (_b = this.ExternalScreenStorage) === null || _b === void 0 ? void 0 : _b.EnableAllScreens();
        }
    }
    onMouseMove(event) {
        if (typeof event.get === 'function' && event.get('resizable') === true) {
            this.onResizingBoundsVisible(event);
        }
        this.lastMouseMoveEvent = event;
        cancelAnimationFrame(this.mouseMoveAnimationFrameId);
        this.mouseMoveAnimationFrameId = requestAnimationFrame(() => {
            this.mouseMoveHandler();
        });
    }
    mouseMoveHandler() {
        var _a;
        if (isNullOrUndefined(this.get))
            return;
        const event = this.lastMouseMoveEvent;
        if (isNullOrUndefined(event))
            return;
        this.onMouseMoveEvt.Raise(event);
        const activeControl = this.get('activeControl');
        if (isNullOrUndefined(activeControl))
            return;
        if (activeControl.get('onProcessMove') === true || activeControl.onProcessResize === true) {
            (_a = this.ExternalScreenStorage) === null || _a === void 0 ? void 0 : _a.DisableAllScreens();
        }
        if (activeControl.get('onProcessMove') === true) {
            const myParams = activeControl.movingParameters;
            const ev = event.original;
            const xShift = myParams.startMoveCoordX - ev.pageX;
            const yShift = myParams.startMoveCoordY - ev.pageY;
            let lastMouseMoveX = myParams.startMyX - xShift;
            let lastMouseMoveY = myParams.startMyY - yShift;
            const possibleControlWidth = activeControl.get('width');
            const activeControlW = isValidNumber(possibleControlWidth)
                ? possibleControlWidth
                : activeControl.getControl().offsetWidth;
            const possibleControlHeight = activeControl.get('height');
            const activeControlH = isValidNumber(possibleControlHeight)
                ? possibleControlHeight
                : activeControl.getControl().offsetHeight;
            const { width: mainWindowW, height: mainWindowH, marginTop: windowMarginTop, marginBottom: windowMarginBottom } = this.getPanelSize();
            if (lastMouseMoveX + activeControlW > mainWindowW) {
                lastMouseMoveX = mainWindowW - activeControlW;
            }
            if (lastMouseMoveX < 0) {
                lastMouseMoveX = 0;
            }
            const maxWindowY = mainWindowH - windowMarginBottom;
            if (lastMouseMoveY + activeControlH > maxWindowY) {
                lastMouseMoveY = maxWindowY - activeControlH;
            }
            if (lastMouseMoveY < windowMarginTop) {
                lastMouseMoveY = windowMarginTop;
            }
            this.lastMouseMoveX = lastMouseMoveX;
            this.lastMouseMoveY = lastMouseMoveY;
            void activeControl.set({ left: lastMouseMoveX, top: lastMouseMoveY });
        }
        if (activeControl.onProcessResize === true) {
            activeControl.onResizing(event);
        }
    }
    getPanelSize() {
        return { width: this.width, height: this.height, marginTop: 0, marginBottom: 0 };
    }
    // #endregion
    // Close button (cross icon).
    onCloseButtonClick() {
        if (this.canCloseFromButton()) {
            this.close();
        }
    }
    canCloseFromButton() {
        return true;
    }
    close() {
        this.dispose();
        this.fire('windowCloseCallback');
        this.OnClose.Raise(this);
    }
    //
    // Раскладываем контролы по id' шкам
    //
    onrender() {
        // вызов бэйс - обязательно!
        super.onrender();
    }
    // #endregion
    getClientPanel() {
        return this.Controls.windowPanelBody.getClientPanel();
    }
    getElementRect(element) {
        if (!element) {
            return;
        }
        const rect = element.getBoundingClientRect();
        const top = rect.top + window.scrollY;
        const left = rect.left + window.scrollX;
        return {
            top,
            left,
            right: left + rect.width,
            bottom: top + rect.height,
            width: rect.width,
            height: rect.height
        };
    }
    onMouseDown(event, isHeader = false) {
        const fullscreenElement = document.fullscreenElement;
        if (fullscreenElement != null &&
            (this.get('isInFullScreenMode') || !fullscreenElement.contains(event.original.currentTarget))) {
            return;
        }
        super.onMouseDown(event, isHeader);
        if (this.onProcessResize) {
            ControlsUtils.Capture.SetCapture(this, event.original);
        }
    }
    onResizing(event) {
        if (!this.captured)
            return;
        const x = this.getPageX(event.original);
        const y = this.getPageY(event.original);
        const resizeParams = this.resizeParameters;
        const dx = resizeParams.down.x - x;
        const dy = resizeParams.down.y - y;
        const myRect = resizeParams.rect;
        const parentOffset = this.getParentOffset(this.el);
        const resizers = resizeParams.resizer;
        const minHeight = this.get('minHeight');
        const maxHeight = this.get('maxHeight');
        const minWidth = this.get('minWidth');
        const maxWidth = this.get('maxWidth');
        const topWindowMargin = TOP_WINDOWS_MARGIN;
        const bottomWindowMargin = BOTTOM_WINDOWS_MARGIN;
        const sideWindowMargin = WINDOW_SIDE_BORDERS_WIDTH;
        if (resizers.top) {
            if (myRect.height > minHeight && myRect.height + dy > minHeight && myRect.height + dy < maxHeight) {
                void this.set({
                    top: y > topWindowMargin ? myRect.top - dy - parentOffset.top : topWindowMargin,
                    height: y > topWindowMargin
                        ? myRect.height + dy - sideWindowMargin / 2
                        : myRect.bottom - topWindowMargin - sideWindowMargin / 2
                });
            }
        }
        if (resizers.bottom) {
            if (myRect.height - dy > minHeight && myRect.height - dy < maxHeight) {
                void this.set({
                    height: y < parentOffset.height - bottomWindowMargin
                        ? myRect.height - dy
                        : parentOffset.height - myRect.top - bottomWindowMargin - sideWindowMargin
                });
            }
        }
        if (resizers.left) {
            if (myRect.height > minHeight && myRect.width + dx > minWidth && myRect.width + dx < maxWidth) {
                void this.set({
                    width: myRect.width + dx - sideWindowMargin / 2,
                    left: myRect.left - dx - parentOffset.left
                });
            }
        }
        if (resizers.right) {
            if (myRect.width - dx > minWidth && myRect.width - dx < maxWidth) {
                void this.set({ width: myRect.width - dx });
            }
        }
        // call event
        const needRaiseEvent = !resizers.noresizer;
        if (needRaiseEvent) {
            this.OnResize.Raise();
        }
    }
    onResizingBoundsVisible(event) {
        const resize = this.getResizer(event.original, event.node);
        let cursor = '';
        if ((resize.top && resize.left) || (resize.bottom && resize.right)) {
            cursor = 'nwse-resize';
        }
        else if ((resize.top && resize.right) || (resize.bottom && resize.left)) {
            cursor = 'nesw-resize';
        }
        else if (resize.top || resize.bottom) {
            cursor = 'ns-resize';
        }
        else if (resize.left || resize.right) {
            cursor = 'ew-resize';
        }
        event.node.style.cursor = cursor;
    }
    getResizer(event, node) {
        const x = this.getPageX(event);
        const y = this.getPageY(event);
        const precision = 5;
        const rect = this.getElementRect(node);
        const limits = y > rect.top - precision &&
            y < rect.bottom + precision &&
            x > rect.left - precision &&
            x < rect.right + precision;
        const resizer = {
            noresizer: true,
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        if (limits) {
            if (y < rect.top &&
                y > rect.top - precision &&
                this.allowResizers.top &&
                this.get('allowHeightResize')) {
                resizer.top = true;
            }
            if (y < rect.bottom + precision &&
                y > rect.bottom &&
                this.allowResizers.bottom &&
                this.get('allowHeightResize')) {
                resizer.bottom = true;
            }
            if (x < rect.left &&
                x > rect.left - precision &&
                this.allowResizers.left &&
                this.get('allowWidthResize')) {
                resizer.left = true;
            }
            if (x < rect.right + precision &&
                x > rect.right &&
                this.allowResizers.right &&
                this.get('allowWidthResize')) {
                resizer.right = true;
            }
        }
        if (resizer.left || resizer.right || resizer.bottom || resizer.top) {
            resizer.noresizer = false;
        }
        return resizer;
    }
    getMousePosition(property, alternative, additionalOffset) {
        return function (event) {
            if (event[property] !== undefined) {
                return event[property];
            }
            else if (event[alternative] !== undefined) {
                return (event[alternative] + document.body[additionalOffset] + document.documentElement[additionalOffset]);
            }
            throw new Error('Pointer position not found');
        };
    }
    getPageX(event) {
        return this.getMousePosition('pageX', 'clientX', 'scrollLeft')(event);
    }
    getPageY(event) {
        return this.getMousePosition('pageY', 'clientY', 'scrollTop')(event);
    }
    getParentOffset(node) {
        return node.offsetParent === document.body ? { left: 0, top: 0 } : this.getElementRect(node.offsetParent);
    }
    center(oninit = false) {
        const control = this.getControl();
        const width = control.offsetWidth;
        const height = control.offsetHeight;
        const mWindow = $(window);
        const wWidth = mWindow.width();
        const wHeight = mWindow.height();
        const left = wWidth > width ? (wWidth - width) / 2 : 0;
        const top = wHeight > height ? (wHeight - height) / 2 : 0;
        void this.set({ left, top });
    }
    dispose() {
        this.clearParentPanelTeardownData();
        super.dispose();
    }
    localize() {
        this.updatePanelHeader();
        void this.set({
            banText: Resources.getResource('panel.caption.NotAllowedMode'),
            symbolLinkTooltip: Resources.getResource('panel.AccountLink.SymbolLink.ToolTip'),
            fullscreenModeBtnTooltip: Resources.getResource('panel.General.FullscreenModeBtn.Tooltip'),
            viewMoreActionsBtnTooltip: Resources.getResource('TradeTool.View more actions'),
            attachDetachPanelText: this.get('attached')
                ? Resources.getResource('panel.external.Dettach')
                : Resources.getResource('panel.external.Attach')
        });
        const exploreTheAppText = Resources.getResource('panel.General.ExploreTheApp.Text');
        const exploreTheAppLinkPartText = Resources.getResource('panel.General.ExploreTheApp.LinkPartText');
        const linkPartIndex = exploreTheAppText.indexOf(exploreTheAppLinkPartText);
        if (exploreTheAppText !== '' && linkPartIndex > 0) {
            const exploreTheAppStart = exploreTheAppText.substring(0, exploreTheAppText.indexOf(exploreTheAppLinkPartText));
            const exploreTheAppEnd = exploreTheAppText.substring(exploreTheAppText.indexOf(exploreTheAppLinkPartText) + exploreTheAppLinkPartText.length);
            void this.set('exploreTheAppStart', exploreTheAppStart);
            void this.set('exploreTheAppLinkPartText', exploreTheAppLinkPartText);
            void this.set('exploreTheAppEnd', exploreTheAppEnd);
        }
        else {
            void this.set('exploreTheAppStart', '');
            void this.set('exploreTheAppLinkPartText', '');
            void this.set('exploreTheAppEnd', '');
        }
    }
    // For closing screens opened from panels.
    setParentPanel(parentPanel) {
        if (!(parentPanel === null || parentPanel === void 0 ? void 0 : parentPanel.teardown)) {
            return;
        }
        this.clearParentPanelTeardownData();
        this.parentPanelTeardownCancelObj = parentPanel.on('teardown', this.onParentPanelTeardown.bind(this));
    }
    onParentPanelTeardown() {
        this.clearParentPanelTeardownData();
        this.afterParentPanelTeardownCallback();
    }
    afterParentPanelTeardownCallback() {
        this.dispose();
    }
    clearParentPanelTeardownData() {
        if (this.parentPanelTeardownCancelObj) {
            this.parentPanelTeardownCancelObj.cancel();
            delete this.parentPanelTeardownCancelObj;
        }
    }
    onKeyDown(event) { }
    onMouseEnter(event) { }
    onMouseLeave(event) { }
    updateBrandingImage() {
        // for About and BrokerInfo screen #117995
        const imgURL = BrandingUtils.GetWebLoginBanner(ThemeManager.themeValue);
        if (!isNullOrUndefined(imgURL) && isValidString(imgURL)) {
            void this.set({ imageUrl: imgURL });
        }
    }
    isShowExploreTheAppLink() {
        return this.get('isShowExploreTheAppLink');
    }
    CustomPreparation() { }
    Properties() {
        const properties = [];
        if (!this.get('isIgnoreLayoutProps')) {
            properties.push(new DynProperty('X_Position', this.get('left'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
            properties.push(new DynProperty('Y_Position', this.get('top'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
            properties.push(new DynProperty('Width', this.get('width'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
            properties.push(new DynProperty('Height', this.get('height'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        }
        properties.push(new DynProperty('Name', this.getType(), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
        properties.push(new DynProperty('WSId', this.get('workSpaceId'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        if (this.get('isAccountLinkShow')) {
            properties.push(new DynProperty('accountLinkValue', this.get('accountLinkValue'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        }
        if (this.get('isSymbolLinkShow')) {
            properties.push(new DynProperty('symbolLinkValue', this.get('symbolLinkValue'), DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));
        }
        return properties;
    }
    callBack(newProperties) {
        const newX = DynProperty.getPropValue(newProperties, 'X_Position');
        const newY = DynProperty.getPropValue(newProperties, 'Y_Position');
        const newWidth = DynProperty.getPropValue(newProperties, 'Width');
        const newHeight = DynProperty.getPropValue(newProperties, 'Height');
        const wsId = DynProperty.getPropValue(newProperties, 'WSId');
        if (this.get('isAccountLinkShow')) {
            const dpVal = DynProperty.getPropValue(newProperties, 'accountLinkValue');
            if (dpVal !== null) {
                void this.set({ accountLinkValue: dpVal });
            }
        }
        if (this.get('isSymbolLinkShow')) {
            const dpVal = DynProperty.getPropValue(newProperties, 'symbolLinkValue');
            if (dpVal !== null) {
                void this.set({ symbolLinkValue: dpVal });
            }
        }
        if (newX !== null &&
            newY !== null &&
            newWidth !== null &&
            newHeight !== null &&
            !this.get('isIgnoreLayoutProps')) {
            this.setBounds(newX, newY, newWidth, newHeight);
        }
        if (wsId !== null) {
            this.setWorkSpaceId(wsId);
        }
    }
    setWorkSpaceId(id) {
        void this.set({ workSpaceId: id });
    }
    getWorkSpaceId() {
        return this.get('workSpaceId');
    }
    closeAddidionalScreens(mainComponent) { }
    enableAccountLinking(accId) {
        if (!this.get('canLinkByAccount')) {
            return;
        }
        accId = accId || LinkedSystem.getAccount(LinkedSystemAccLinkingValue);
        this.updateAccountLinkVisible(true);
    }
    disableAccountLinking() {
        if (!this.get('canLinkByAccount')) {
            return;
        }
        this.updateAccountLinkVisible(false);
    }
    updateAccountLinkVisible(visible, force = false) {
        if (!this.get('canLinkByAccount') && !force) {
            return;
        }
        void this.set('isAccountLinkShow', visible);
        this.updateLinkVisible();
    }
    getIsAccountLinkShow() {
        return this.get('isAccountLinkShow') && !DataCache.EnableForceLinkingByAccount();
    }
    OnAccountLinking() {
        return this.get('isAccountLinkShow');
    }
    updateLinkVisible() { }
    updatePanelHeader() {
        if (!isValidString(this.headerLocaleKey)) {
            return;
        }
        let header = Resources.getResource(this.headerLocaleKey);
        const isBeta = this.get('isBeta');
        if (isBeta) {
            header += ` (${Resources.getResource('property.Beta')})`;
        }
        void this.set({ header });
    }
    AttachClick(event) {
        var _a, _b, _c, _d;
        if (FullScreenManager.IsFullScreenMode) {
            return;
        }
        const panelType = (_d = (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.component) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.getType) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : 'subclass';
        console.warn(`AttachClick method should be overridden in ${panelType}`);
    }
    onViewMoreActionsClick(event) {
        const btn = this.find('.js-button-view-more-panel-actions');
        const btnRect = btn.getBoundingClientRect();
        const items = [];
        if (this.get('isAllowAttachDetachPanel') && !FullScreenManager.IsFullScreenMode) {
            items.push({
                type: 'item',
                id: 'attachDetachPanel',
                text: this.get('attachDetachPanelText'),
                onClick: () => {
                    this.AttachClick(event);
                }
            });
        }
        if (items.length > 0) {
            void this.set('isViewMoreMenuOpened', true);
            showContextMenu({
                position: { x: btnRect.x, y: btnRect.y + btnRect.height },
                items: items,
                onClose: () => {
                    void this.set('isViewMoreMenuOpened', false);
                }
            });
        }
    }
    setSize(w, h) {
        void this.set({ width: w, height: h });
    }
    gotFocus() {
        super.gotFocus();
        const isDockable = this.get('dockablePanel');
        if (isDockable) {
            if (this.containerSetFocus) {
                this.containerSetFocus(true);
            }
        }
        if (!this.get('attached') || !isDockable) {
            void this.set('zIndex', TerceraWindowBase.getNextZIndex());
        }
    }
    lostFocus() {
        super.lostFocus();
        if (this.get('dockablePanel')) {
            if (this.containerSetFocus) {
                this.containerSetFocus(false);
            }
        }
        if (this.get('isAutoClose')) {
            this.close();
        }
    }
    TickAsync() { }
    populate(addPanel) { }
    repopulate() { }
    setVisibility(visible) {
        void this.set({ visible });
    }
    // help in migration process: get lost WSid
    GetWSIdFromProperty(properties) {
        return DynProperty.getPropValue(properties, 'WSId');
    }
    getInstrument() {
        return null;
    }
    updateSettings() {
        this.forceUpdate = true;
    }
    localizeAccountLinkTooltip() {
        void this.set({ accountLinkTooltip: this.tooltipForAccountLink() });
    }
    isAttached() {
        return this.get('attached') || this.get('dockablePanel');
    }
    tooltipForAccountLink(account) {
        let tooltip = Resources.getResource('panel.AccountLink.CanFilterToolTip');
        if (!this.get('canFilterByAccount')) {
            tooltip = Resources.getResource('panel.AccountLink.ToolTip');
            const acc = account || this.get('accountItem') || this.get('account');
            if (acc != null) {
                tooltip += ' : ' + acc.FullAccString;
            }
            else {
                tooltip = Resources.getResource('panel.accounts.AccountLink.ToolTip'); // AssetBalancesPanel
            }
        }
        return tooltip;
    }
    getProperties(isCommon) {
        const props = this.Properties();
        const result = [];
        for (let i = 0; i < props.length; i++) {
            const prop = props[i];
            const isStyleProperty = prop.group !== DynProperty.HIDDEN_GROUP && DynProperty.isStyleProperty(prop.type);
            if (isCommon && !isStyleProperty) {
                result.push(prop);
                continue;
            }
            if (!isCommon && isStyleProperty) {
                result.push(prop);
                continue;
            }
        }
        return result;
    }
    addScrollToContainer(containerSelector = '.js-win-innerContainer') {
        const itemContainer = this.find(containerSelector);
        HtmlScroll.addScroll(itemContainer);
    }
    resizePanelToFitScreen() {
        /* Check that the window is fully within the screen */
        const winElement = this.find('*');
        const winRect = winElement.getBoundingClientRect();
        const parentRect = winElement.parentElement.getBoundingClientRect();
        const isPanelOverflowing = winRect.bottom > parentRect.bottom;
        if (isPanelOverflowing) {
            /* If the window doesn't fit, move it up by the overflow amount */
            const offset = winRect.bottom - parentRect.bottom;
            const newTopPosition = Math.max(winRect.top - offset, parentRect.top);
            this.setLocation(winRect.left, newTopPosition);
        }
    }
}
TerceraWindowBase.INITIAL_WINDOW_Z_INDEX = 199;
TerceraWindowBase.ZIndex = TerceraWindowBase.INITIAL_WINDOW_Z_INDEX;
// #region enums
export var TerceraWindowBaseEvents;
(function (TerceraWindowBaseEvents) {
    TerceraWindowBaseEvents["OnClosed"] = "OnClosed";
})(TerceraWindowBaseEvents || (TerceraWindowBaseEvents = {}));
// #endregion
ContainerControl.extendWith(TerceraWindowBase, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            isRelativeStyle: false,
            showHeader: true,
            showFooter: true,
            movable: true,
            resizable: true,
            header: '',
            headerInnerHTML: '',
            attachDetachPanelText: '',
            isAllowAttachDetachPanel: false,
            dockablePanel: false,
            attached: false,
            alwaysMiddle: false,
            showFullscreenCloud: false,
            showModalMask: false,
            isLookup: false,
            showOverflow: false,
            minWidth: 100,
            minHeight: 100,
            maxWidth: 5000,
            maxHeight: 5000,
            showBorder: true,
            showFullscreenModeButton: false,
            forbiddenPanel: false,
            banText: '',
            symbolLinkTooltip: 'Symbol link',
            accountLinkTooltip: 'Account link',
            fullscreenModeBtnTooltip: '',
            viewMoreActionsBtnTooltip: '',
            style_addition_jsWin: '',
            style_addition_body: '',
            style_addition_header: '',
            style_addition_footer: '',
            footer_height: 47,
            closeBtnVisible: true,
            isShowExploreTheAppLink: false,
            exploreTheAppLink: ApplicationInfo.exploreTheAppLink,
            exploreTheAppStart: '',
            exploreTheAppLinkPartText: '',
            exploreTheAppEnd: '',
            widthInPercent: null,
            heightInPercent: null,
            isAccountLinkShowState: false,
            isAccountLinkShow: false,
            windowCloseCallback: null,
            isAutoClose: false,
            isViewMoreMenuOpened: false,
            isInFullScreenMode: false,
            allowWidthResize: true,
            allowHeightResize: true
        };
    },
    computed: {
        isVisibileViewMoreActionsButton: function () {
            return this.get('isAllowAttachDetachPanel') === true && !FullScreenManager.IsFullScreenMode;
        }
    },
    partials: {
        alwaysMiddlePart: TerceraAlwaysMiddlePartPartial
    }
});
